import { createFileRoute } from '@tanstack/react-router'

import { QuoteImportPage } from '@/pages/quotes/import/QuoteImportPage'

export const Route = createFileRoute('/_authenticated/_dashboard/quotes/import/')({
  component: QuoteImportPage,
})
